import React, { useState } from 'react';
import { Icon, useAccordionContext } from '@ver-uds/uswds-react';
import { Button } from '@ver-uds/react';

export interface AccordionReadToggleButtonProps {
  controls: string;
}

export default function ToggleButton({ controls }: AccordionReadToggleButtonProps): JSX.Element {
  const { toggle, isOpen } = useAccordionContext();
  const expanded = isOpen(controls);
  const [content, setContent] = useState('Read More');

  const handleClick = (): void => {
    setContent(`Read ${!isOpen(controls) ? 'Less' : 'More'}`);
    toggle(controls);
  };

  return (
    <Button
      type="button"
      variant="secondary"
      size="small"
      aria-controls={controls}
      aria-expanded={expanded}
      aria-label="Button to visually expand or collapse text. This is un-necessary for screen readers."
      onClick={handleClick}
      iconRight={expanded ? <Icon name="arrow_drop_up" size={6} /> : <Icon name="arrow_drop_down" size={7} />}
    >
      {content}
    </Button>
  );
}
